import { call, put, select, takeLatest } from 'redux-saga/effects'

import * as Action from '../actions'
import ActionType from '../constants/actionTypes'
import * as Data from '../data'
import { Question } from '../selectors'

export default function* saga() {
  yield takeLatest(ActionType.QUESTION_REQUIRED, requireQuestion)
  yield takeLatest(ActionType.FETCH_QUESTIONS_REQUEST, requestQuestions)
}

export function* requireQuestion() {
  const loaded = yield select(Question.loaded)

  if (!loaded) {
    yield put(Action.requestQuestions())
  }
}

export function* requestQuestions() {
  try {
    const question = yield call(Data.fetchQuestion)

    yield put(Action.fetchQuestionsSuccess(question))
  } catch (error) {
    yield put(Action.fetchQuestionsFailure(error))
  }
}



// WEBPACK FOOTER //
// ./client/modules/debate/sagas/question.js